import React, { useCallback } from "react"
import { msg } from "@lingui/macro"
import { Toggle } from "@silversea-ssc/ui-components-react"
import { AirFareOption, RequestAirFare } from "@ssc-booking/api-contracts"
import { useLingui } from "@lingui/react"
import { AirClassOption, UpgradableIncludedAirFare } from "../../../_common/read-models/fare-card"
import { formatAmount } from "../../../../_common/format/localization"

type Props = {
    current: RequestAirFare | undefined
    onAirFareChanged: (option: AirClassOption) => void
    options: UpgradableIncludedAirFare
}

const AirFareToggle: React.FC<React.PropsWithChildren<Props>> = ({ current, onAirFareChanged, options }) => {
    const { i18n } = useLingui()
    const onAirFareCheckedChange = useCallback(
        (checked: boolean) => {
            onAirFareChanged(checked ? options.upgrade : options.base)
        },
        [onAirFareChanged, options.upgrade, options.base],
    )
    const formattedAmount = formatAmount(AirFareOption.totalAmount(options.upgrade))
    const label = i18n._(msg`BUSINESS CLASS +${formattedAmount}`)
    return (
        <Toggle
            label={label}
            onChange={onAirFareCheckedChange}
            checked={current === options.upgrade.airFare}
            dataContentPiece="upgrade_air_class"
        />
    )
}

export default AirFareToggle
